var _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiArrowLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-ui--arrow-left-outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.336 0H11.64v20H.336z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-ui--arrow-left-outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.871 9.084L6.894 5.06 5.834 4 0 9.834l5.833 5.833 1.061-1.06-4.023-4.023H12v-1.5z",
    fillRule: "evenodd"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--arrow-left-outline-9880733cbceae0834de8f2c8bdd7e983.svg";
export { SvgIconUiArrowLeftOutline as Component };